module.exports = __webpack_public_path__ + "static/media/headertongyu2.b74da167.png";